import { get, set, StorageKeys } from './storage';
import { isSafeString, log, safeJsonParse } from './utils';

export interface StoredUtms {
  source?: string;
  medium?: string;
  campaign?: string;
  content?: string;
  term?: string;
  id?: string;
  /** When these UTMs were captured (Unix ms) */
  ts: number;
  /** Origin + pathname where capture happened */
  page: string;
}

const UTM_KEYS = ['source', 'medium', 'campaign', 'content', 'term', 'id'] as const;
type UtmKey = (typeof UTM_KEYS)[number];

/**
 * Read UTMs from the current URL. Returns null if none present.
 * Values are validated against the same isSafeString check used for
 * attribution sources, so XSS payloads in UTMs can't reach the form URL.
 */
function readUtmsFromUrl(): StoredUtms | null {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  const out: StoredUtms = {
    ts: Date.now(),
    page: window.location.origin + window.location.pathname,
  };
  let any = false;
  for (const k of UTM_KEYS) {
    const v = params.get(`utm_${k}`);
    if (v && isSafeString(v)) {
      out[k] = v;
      any = true;
    }
  }
  return any ? out : null;
}

/**
 * Capture UTMs from the current page URL and persist them.
 * Called on pixel boot. Last-touch semantics: new UTMs overwrite older ones.
 */
export function captureUtms(): StoredUtms | null {
  const fresh = readUtmsFromUrl();
  if (!fresh) return null;
  set(StorageKeys.utms, JSON.stringify(fresh));
  log('captured UTMs', fresh);
  return fresh;
}

export function loadUtms(): StoredUtms | null {
  const raw = get(StorageKeys.utms);
  if (!raw) return null;
  const parsed = safeJsonParse<StoredUtms | null>(raw, null);
  if (!parsed || typeof parsed !== 'object') return null;
  return parsed;
}

export function clearUtms(): void {
  set(StorageKeys.utms, '');
}
